<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="saleFilter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="saleFilter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import securityService from "../services/securityService";
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                memberForm: () => import('../forms/MemberForm'),
                saleFileForm: () => import('../forms/SaleFileForm'),
                fields: [
                    { type: 'text', text: 'Vendor Declaration Number', value: 'vendorDeclarationNumber', rules: [v => !!v || 'Vendor Declaration Number is required', v => !(v && v.length > 50) || 'Vendor Declaration Number must be less than 50 characters'], isRequired: true, maxLength: 50 },
                    { type: 'datetime', text: 'Purchased On', value: 'purchasedOn', rules: [v => !!v || 'Purchased On is required'], isRequired: true },
                    { type: 'datetime', text: 'Delivery On', value: 'deliveryOn', rules: [v => !!v || 'Delivery On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Seller Member', value: 'sellerMemberId', rules: [v => !!v || 'Seller Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Seller Name (if non-member)', value: 'sellerName', rules: [v => !(v && v.length > 100) || 'Seller Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'autocomplete', text: 'Buyer Member', value: 'buyerMemberId', rules: [], form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members', ignoreFilter: true },
                    { type: 'text', text: 'Buyer Name (if non-member)', value: 'buyerName', rules: [v => !(v && v.length > 100) || 'Buyer Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'number', text: 'Price', value: 'price', rules: [] },
                    { type: 'number', text: 'Supervision Period In Months', value: 'supervisionPeriodInMonths', rules: [v => (v !== null && v !== '') || 'Supervision Period In Months is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Recent AFB Evidence', value: 'hasRecentAfbEvidence', rules: [v => (v !== null && v !== '') || 'Has Recent AFB Evidence is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Recent Honey Culture Test', value: 'hasRecentHoneyCultureTest', rules: [v => (v !== null && v !== '') || 'Has Recent Honey Culture Test is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Antibiotic Treatment', value: 'hasAntibioticTreatment', rules: [v => (v !== null && v !== '') || 'Has Antibiotic Treatment is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Toxic Substance Exposure', value: 'hasToxicSubstanceExposure', rules: [v => (v !== null && v !== '') || 'Has Toxic Substance Exposure is required'], isRequired: true },
                    { type: 'checkbox', text: 'Has Proximity To GMO', value: 'hasProximityToGmo', rules: [v => (v !== null && v !== '') || 'Has Proximity To GMO is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Beekeeper Declaration Completed', value: 'isBeekeeperDeclarationCompleted', rules: [v => (v !== null && v !== '') || 'Is Beekeeper Declaration Completed is required'], isRequired: true },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'saleId', form: () => import('../forms/SaleFileForm') }
                ],
                apiMethod: 'Sales',
                formTitle: 'Sale',
            }
        },
        computed: {
            saleFilter() {
                var memberId = securityService.getMemberId();
                if (memberId) {
                    return {
                        sellerMemberId: memberId,
                        ...this.filter
                    };
                }
                return this.filter;
            }
        }
    };
</script>
